import { Injectable } from '@angular/core';
import {ParentService} from '../ParentClass/ParentService';
import {Router} from '@angular/router';
import {Http, Response} from '@angular/http';
import {constant} from '../../../app.constants';
import {Observable} from 'rxjs/Observable';

@Injectable()
export class ChangePasswordService extends ParentService {

  private progressObserver: any;
  private progress: any;

  constructor( private _http: Http, private route: Router) {
    super();
    // this.verifyToken(this._http, route);
  }

  /**
   * @name changePassword
   * @description
   * @param data
   */
  changePassword(data) {
    return this._http
      .put(constant.RESTOREPASSWORD, JSON.stringify(data), this.headerPost())
      .map((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error.json()));
  }

  newChangePassword(data) {
    return this._http
      .put(constant.CHANGE_PASSWORD, JSON.stringify(data), this.headerPost())
      .map((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error.json()));
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/A2-utils/change-password/change-password.service.ts